<template>
  <div :class="bem.b()">
    <div :class="bem.m('colors')">
      <div
        v-for="(item, index) in rgbaColors"
        :key="index"
        :class="{
          [bem.m('color-selector')]: true,
          [bem.is('selected')]: item.selected,
          [bem.is('alpha')]: item._alpha < 100
        }"
        @click="handleSelect(index)"
      >
        <div :style="{ backgroundColor: item.value }"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, watchEffect } from 'vue'
import { preDefineProps, parseColors } from '../config'
import Color from '../config/color'
import { useOptions } from '../config/use-options'
import { createNamespace } from '@ll-plus/utils'
import type { IUseOptions } from '../config/use-options'

// Config
defineOptions({ name: 'PreDefine' })
const props = defineProps(preDefineProps)
const bem = createNamespace('pre-define')

//Data
// @ts-ignore
const currentColor: IUseOptions['currentColor'] = useOptions()?.currentColor

// data
const rgbaColors = ref<Color[]>(parseColors(props.colors, props.color))

// methods
const handleSelect = (index: number) => {
  props.color.fromString(props.colors[index])
}

// watch
watch(
  () => currentColor.value,
  val => {
    if (val) {
      const color: Color = new Color()
      color.fromString(val)
      // @ts-ignore
      rgbaColors.value.forEach((item: Color) => {
        item.selected = color.compare(item)
      })
    }
  }
)
watchEffect(() => {
  rgbaColors.value = parseColors(props.colors, props.color)
})
</script>
